import { BaSeParagraph, BaSeTheme } from '@base/react';
import * as React from 'react';

export const DeleteText = ({ texts }) => (
  <div style={{ padding: '4px 0' }}>
    {texts?.map((text, index) => (
      <BaSeParagraph
        key={index}
        color={BaSeTheme.colors.institucionais.cinzaSebrae45}
      >
        {text}
      </BaSeParagraph>
    ))}
  </div>
);
